import { AnnualReportAuditorSigningStepsActionTypes } from "models/actionTypes/annualReportAuditorSigningStepsActionTypes";
import { ReduxConstants } from "utils/constants";

export const annualReportSigned = (id: number): AnnualReportAuditorSigningStepsActionTypes => {
  return {
    type: ReduxConstants.AnnualReportAuditorSigningStepsActions.ANNUAL_REPORT_AUDITOR_STEP_SIGNED,
    payload: id,
  };
};
